module.exports = __webpack_public_path__ + "img/slide2_img3.417c08d1.png";